import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[color:var(--sp-subtle)] py-10 px-6">
      <div className="max-w-3xl mx-auto sp-card p-10">
        <Link to="/" className="inline-flex items-center gap-1 text-xs font-bold text-[color:var(--sp-text-muted)] hover:text-[color:var(--sp-brand)] mb-6">
          <ArrowLeft className="h-3 w-3" /> Torna a Memento
        </Link>
        <h1 className="font-display text-4xl font-black">Termini e Condizioni di Servizio</h1>
        <p className="text-xs text-[color:var(--sp-text-muted)] mt-2">Ultimo aggiornamento: 7 febbraio 2026</p>

        <div className="prose prose-slate max-w-none mt-8 space-y-6 text-sm leading-relaxed">
          <section>
            <h2 className="font-display text-xl font-black">1. Oggetto</h2>
            <p>
              Memento è un software gestionale in modalità SaaS fornito da Salon Up S.r.l. per
              parrucchieri, saloni di bellezza e attività affini. I presenti termini regolano l&apos;uso della
              piattaforma da parte di titolari di attività (&quot;Cliente&quot;) e dei loro utenti autorizzati.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-black">2. Registrazione e Account</h2>
            <p>
              Per utilizzare Memento devi creare un account fornendo dati veritieri e aggiornati.
              Sei responsabile della sicurezza delle credenziali di accesso. Devi notificare
              immediatamente qualsiasi uso non autorizzato del tuo account.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-black">3. Utilizzo consentito</h2>
            <p>Accetti di utilizzare Memento in conformità con la legge e ti impegni a NON:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Utilizzare la piattaforma per attività illecite o fraudolente</li>
              <li>Inviare comunicazioni non sollecitate (spam) tramite email o WhatsApp</li>
              <li>Caricare contenuti che violino diritti di terzi (copyright, immagine)</li>
              <li>Effettuare attività di reverse-engineering, scraping massivo, o copia della piattaforma</li>
              <li>Utilizzare Memento per raccogliere dati personali senza informativa adeguata ai tuoi clienti finali</li>
              <li>Aggirare i limiti tecnici o le protezioni di sicurezza</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-black">4. Responsabilità dei dati dei clienti finali</h2>
            <p>
              Ogni Cliente Memento è <strong>Titolare autonomo del trattamento</strong> per i dati dei
              propri clienti finali (persone che frequentano il salone). Sei responsabile di:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Fornire un&apos;informativa privacy ai tuoi clienti finali</li>
              <li>Raccogliere i consensi necessari (marketing SMS/WhatsApp/email)</li>
              <li>Rispondere alle richieste di esercizio dei diritti (accesso, cancellazione, ecc.)</li>
              <li>Non utilizzare i dati per finalità diverse da quelle dichiarate ai clienti finali</li>
            </ul>
            <p className="mt-2">
              Salon Up S.r.l. agisce come <strong>Responsabile del trattamento</strong> (art. 28 GDPR) ai
              tuoi ordini. Su richiesta forniamo un DPA (Data Processing Agreement) firmato.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-black">5. Prezzi e pagamenti</h2>
            <p>
              I prezzi correnti sono indicati sul sito. Al momento Memento è offerto in modalità
              early-access ai clienti dell&apos;agenzia. I costi variabili (messaggi WhatsApp inviati
              tramite Meta Cloud API) potranno essere addebitati separatamente in base ai volumi,
              con notifica preventiva di almeno 15 giorni.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-black">6. Servizi di terze parti</h2>
            <p>
              Memento si integra con servizi di terze parti (Meta WhatsApp Cloud API, Resend, Google
              Calendar, ecc.). L&apos;uso di tali servizi è soggetto ai loro termini. Non siamo
              responsabili per interruzioni, modifiche di prezzo o disservizi di questi fornitori.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-black">7. Proprietà intellettuale</h2>
            <p>
              Memento, il suo codice, il marchio, il design e la documentazione sono di proprietà
              esclusiva di Salon Up S.r.l. I dati che carichi restano di tua proprietà — su richiesta
              te li restituiamo in formato leggibile entro 30 giorni.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-black">8. Limitazione di responsabilità</h2>
            <p>
              Nei limiti massimi consentiti dalla legge, Salon Up S.r.l. non è responsabile per danni
              indiretti, perdita di profitti o dati derivanti dall&apos;uso della piattaforma. La
              responsabilità complessiva è limitata al canone pagato negli ultimi 12 mesi.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-black">9. Recesso e sospensione</h2>
            <p>
              Puoi disattivare l&apos;account in qualsiasi momento. Possiamo sospendere l&apos;account in caso
              di violazione dei presenti termini, previa notifica di 7 giorni salvo casi urgenti (frode,
              abuso). All&apos;chiusura, i dati restano disponibili per il download per 30 giorni.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-black">10. Legge applicabile e foro competente</h2>
            <p>
              I presenti termini sono regolati dalla legge italiana. Per qualsiasi controversia il foro
              competente in via esclusiva è quello di <strong>Tivoli (RM)</strong>, salvo diverse
              disposizioni inderogabili a tutela del consumatore.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
